import { AgFinancingFilesContext, Phase1 } from '@indigo-ag/schema';
import { IIbamaInfo, ILaborInfo, ISerasaInfo, IStateJudicialCheckInfo } from 'shared';

export const getIbamaInfoFromPhase = (phaseInfo?: Phase1): IIbamaInfo | undefined => {
  if (phaseInfo) {
    const ibamaFiles = phaseInfo.files ? phaseInfo.files.filter(f => f.context === AgFinancingFilesContext.IBAMA) : [];
    const { ibamaEvaluation, ibamaNotes } = phaseInfo;

    return ibamaEvaluation || ibamaNotes || ibamaFiles.length
      ? {
          ibamaEvaluation,
          ibamaNotes,
          ibamaFiles
        }
      : undefined;
  } else {
    return undefined;
  }
};

export const getSerasaInfoFromPhase = (phaseInfo?: Phase1): ISerasaInfo | undefined => {
  if (phaseInfo) {
    const serasaFiles = phaseInfo.files
      ? phaseInfo.files.filter(f => f.context === AgFinancingFilesContext.SERASA)
      : [];
    const { serasa, serasaNotes, serasaEvaluation } = phaseInfo;

    return (serasa && serasa.length) || serasaNotes || serasaFiles.length || serasaEvaluation
      ? {
          serasaEvaluation,
          serasa,
          serasaNotes,
          serasaFiles
        }
      : undefined;
  } else {
    return undefined;
  }
};

export const getLaborInfoFromPhase = (phaseInfo?: Phase1): ILaborInfo | undefined => {
  return phaseInfo && phaseInfo.laborEvaluation
    ? {
        laborEvaluation: phaseInfo.laborEvaluation
      }
    : undefined;
};

export const getStateJudicialCheckInfoFromPhase = (phaseInfo?: Phase1): IStateJudicialCheckInfo | undefined => {
  if (phaseInfo) {
    const stateJudicialCheckFiles = phaseInfo.files
      ? phaseInfo.files.filter(f => f.context === AgFinancingFilesContext.STATE_JUDICIAL_CHECK)
      : [];
    const { stateJudicialCheck, stateJudicialCheckNotes, stateJudicialCheckEvaluation } = phaseInfo;

    return (stateJudicialCheck && stateJudicialCheck.length) ||
      stateJudicialCheckNotes ||
      stateJudicialCheckFiles.length ||
      stateJudicialCheckEvaluation
      ? {
          stateJudicialCheckEvaluation,
          stateJudicialCheck,
          stateJudicialCheckNotes,
          stateJudicialCheckFiles
        }
      : undefined;
  } else {
    return undefined;
  }
};
